import styled, { css, SimpleInterpolation } from "styled-components";
import { Icon } from "../Icon";
import { TruncateText } from "../TruncateText";
import { style } from "../style";

const TAG_HEIGHT = style.vars.space["5"];
const TAG_SPACING = style.vars.space["2"];

type TagContainerStyles = {
  $hasActionButton?: boolean;
  $hideTagIcon?: boolean;
};

export const TagContainer = styled.div<TagContainerStyles>`
  display: inline-flex;
  align-items: center;
  color: ${style.colors.grey.darkest};
  height: ${TAG_HEIGHT};
  line-height: ${TAG_HEIGHT};
  min-width: 56px; /* Hard constraint set by design */
  padding-top: 0;
  padding-bottom: 0;
  /* If tag icon is omitted, omit left padding */
  padding-left: ${({ $hideTagIcon }) => ($hideTagIcon ? 0 : TAG_SPACING)};
  /* If tag text is followed by a (copy or remove) button, omit right padding */
  padding-right: ${({ $hasActionButton }) => ($hasActionButton ? 0 : TAG_SPACING)};
  background-color: ${style.colors.grey.lightest};
  border-radius: ${style.vars.borderRadius.base};
  margin: ${style.vars.space["1"]};
`;

export const TagText = styled(TruncateText)`
  flex: 1;
  margin-left: ${TAG_SPACING};
  font-size: ${style.vars.fontSize.base};
`;

export const TagIcon = styled(Icon).attrs((props) => ({
  icon: props.icon ? props.icon : "product-tag",
}))`
  flex-shrink: 0;
`;

export const tagActionButtonStyles = (): SimpleInterpolation => {
  return css`
    color: ${style.colors.grey.dark};
    height: ${TAG_HEIGHT};
    min-width: ${TAG_HEIGHT};
    width: ${TAG_HEIGHT};

    &:hover {
      background-color: ${style.colors.grey.light};
    }
  `;
};
